import React from 'react'
import ServiceHero from '../ourService/ServiceHero'
import WhyAppnext from '../ourService/WhyAppnext'
import AiInsights from '../ourService/AiInsights'
import ServerSection from '../ourService/ServerSection'
import CtaSection from '../ourService/CtaSection'
import ProjectSection from '../ourService/ProjectSection'
import MarqueeSection from './MarqueeSection'
import ClientMarquee from '../ourService/ClientMarquee'

const Test = () => {
  return (
    <div>
      <ServiceHero/>
      <WhyAppnext/>
      <AiInsights/>
      <ServerSection/>
      <CtaSection/>
      <ProjectSection/>
    </div>
  )
}

export default Test